import { RoomInfo } from "../../types";

/**
 * * Модель подтверждения окончания загрузки файла
 */
export class CompleteAddFileRequestModel {
  /**ID загрузки */
  UploadId!: string;
  /**ID файла */
  FileId!: number;
  /**Комната */
  Room?: RoomInfo;

  constructor(obj?: Partial<CompleteAddFileRequestModel>) {
    Object.assign(this, obj);
  }
}
